import { useState } from "react";

export default function NavBar({ onNavigate, isSelected }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigate = (page) => {
    onNavigate(page);
    setIsMenuOpen(false); // Close menu after navigation on mobile
  };

  return (
    <nav>
      <span className="navName">Tiffany's Portfolio 🧸</span>

      {/* Hamburger Menu Button for Mobile */}
      <button
        className="hamburger-menu"
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        {isMenuOpen ? (
          <span className="close-icon">✕</span>
        ) : (
          <>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </>
        )}
      </button>

      <ul className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
        <li>
          <button
            className={`navButtons ${
              isSelected === "home" ? "selectedNav" : ""
            }`}
            onClick={() => handleNavigate("home")}
          >
            Home
          </button>
        </li>
        <li>
          <button
            className={`navButtons ${
              isSelected === "resume" ? "selectedNav" : ""
            }`}
            onClick={() => handleNavigate("resume")}
          >
            Resume
          </button>
        </li>
        <li>
          <button
            className={`navButtons ${
              isSelected === "projects" ? "selectedNav" : ""
            }`}
            onClick={() => handleNavigate("projects")}
          >
            Projects
          </button>
        </li>
      </ul>
    </nav>
  );
}
